import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import portfolioData from '../data/portfolio';
import ExperienceEntry from '../components/ExperienceEntry';
import SocialLinks from '../components/SocialLinks';
import LanguageSwitch from '../components/LanguageSwitch';

function Home({ language, onLanguageChange }) {
  const data = portfolioData[language] || portfolioData.en;
  const linkedinUrl = 'https://www.linkedin.com/in/murilofarias/';

  return (
    <div className="Home">
      <Link to="/about" className="button">
        {language === 'en' ? 'About me' : 'Sobre mim'}
      </Link>
      <br />
      <article className="App-profile">
        <header className="App-profile-header">
          <h1>{data.name}</h1>
          <p className="App-profile-role">{data.role}</p>
          <p className="App-profile-location">{data.location}</p>
          <LanguageSwitch language={language} onChange={onLanguageChange} />
        </header>

        <section className="App-section">
          <h2>{language === 'en' ? 'About' : 'Sobre'}</h2>
          <p>{data.summary}</p>
        </section>

        <section className="App-section">
          <h2>{language === 'en' ? 'Skills' : 'Habilidades'}</h2>
          <ul className="App-skills-list">
            {data.skills.map((skill, idx) => (
              <li key={idx}>{skill}</li>
            ))}
          </ul>
        </section>

        <section className="App-section">
          <h2>{language === 'en' ? 'Experience' : 'Experiência'}</h2>
          <ol className="App-experience-list">
            {data.roles.map((role, idx) => (
              <ExperienceEntry key={idx} role={role} lang={language} />
            ))}
          </ol>
          <p className="App-profile-linkedin">
            {language === 'en'
              ? 'View full profile on '
              : 'Ver perfil completo no '}
            <a href={linkedinUrl} target="_blank" rel="noopener noreferrer">
              LinkedIn
            </a>
          </p>
        </section>
      </article>

      <SocialLinks
        title={
          language === 'en'
            ? 'For more information, get in touch or check professional profiles.'
            : 'Para mais informações, entre em contato ou acesse perfis profissionais.'
        }
      />
    </div>
  );
}

Home.propTypes = {
  language: PropTypes.oneOf(['en', 'pt-BR']).isRequired,
  onLanguageChange: PropTypes.func.isRequired,
};

export default Home;
